import script from "./ProgressStatsCardComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressStatsCardComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressStatsCardComponent.vue?vue&type=style&index=0&id=2b99f4c4&scoped=true&lang=scss"

import exportComponent from "/builds/lightswitch/reflective/reflective-learning-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b99f4c4"]])

export default __exports__